import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '.';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    flow: null,
    timerSeconds: null,
    showCookieBanner: true,
  },
  reducers: {
    setFlow: (state, action) => {
      state.flow = action.payload;
    },
    setTimerSeconds: (state, action) => {
      state.timerSeconds = action.payload;
    },
    setShowCookieBanner: (state, action: PayloadAction<boolean>) => {
      state.showCookieBanner = action.payload;
    },
  },
});

export const { setFlow, setTimerSeconds, setShowCookieBanner } = appSlice.actions;

export const selectFlow = (state: any) => state.app.flow;
export const selectTimerSeconds = (state: any) => state.app.timerSeconds;
export const selectShowCookieBanner = (state: RootState) => state.app.showCookieBanner;

export default appSlice.reducer;
